/*
    A ref Parameter must be passed
    Although this doesn't offer dynamism to have 2 cameras/videos at the same time (which can be implemented later),
    It is not hardcoded just to make the developer aware that they must set it on the component call as well
 */
export default function (ref) {
    return {
        created: function () {
        },
        methods: {
            initCamera(callback) {
                this.$refs[ref].initCamera(callback);
            },
            takePicture() {
                return this.$refs[ref].takePicture();
            },
            nextVideoSource() {
                this.$refs[ref].nextVideoSource();
            },
            stopVideoCapture(callback) {
                this.$refs[ref].stopVideoCapture(callback);
            },
            retakePhoto(){
                this.$refs[ref].retakePhoto();
            },
            isCameraOn(){
                    return this.$refs[ref].isCameraOn()
            },
            pauseCamera(){
                return this.$refs[ref].pauseCamera()
            }
        }
    }
}
